import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const TransparencyView = lazy(async () => {
  const m = await import("@/features/workforce/components/transparency-view");
  return { default: m.TransparencyView };
});

export const transparencyRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/transparency",
  component: () => (
    <Suspense fallback={null}>
      <TransparencyView />
    </Suspense>
  ),
});
